import { OddStyles } from "sb-resp-lib";
import { Selection } from "../../contracts";

export const mapSelectionsOdds = (selections: Selection[], oddStyle: number) => {
   return selections.map(
            (selection) => {
                selection.odds = selection.displayOdds[OddStyles[oddStyle]];
                return selection;
            }
        );
}